module.exports = __webpack_public_path__ + "static/images/ww.82bda48.png";